export const CyFilterHeader = {
  ButtonToggleFilter: "ButtonToggleFilter",
  ButtonOrderBy: "ButtonOrderBy",
} as const;
